import dress1 from '../images/DressLogo Pics/11.png'
import dress1a from '../images/DressLogo Pics/11a.png'
import dress2 from '../images/DressLogo Pics/2.png'
import dress2a from '../images/DressLogo Pics/2a.png'
import dress3 from '../images/DressLogo Pics/3.png'
import dress3a from '../images/DressLogo Pics/3a.png'
import dress4 from '../images/DressLogo Pics/4.png'
import dress4a from '../images/DressLogo Pics/4a.png'
import dress5 from '../images/DressLogo Pics/5.png'
import dress5a from '../images/DressLogo Pics/5a.png'
import dress6 from '../images/DressLogo Pics/6.png'
import dress6a from '../images/DressLogo Pics/6a.png'
import dress7 from '../images/DressLogo Pics/7.png'
import dress7a from '../images/DressLogo Pics/7a.png'
import dress8 from '../images/DressLogo Pics/8.png'
import dress8a from '../images/DressLogo Pics/8a.png'
import dress9 from '../images/DressLogo Pics/9.png'
import dress9a from '../images/DressLogo Pics/9a.png'
import dress10 from '../images/DressLogo Pics/10.png'
import dress10a from '../images/DressLogo Pics/10a.png'
import dress11 from '../images/DressLogo Pics/1.png'
import dress11a from '../images/DressLogo Pics/1a.png'
import dress12 from '../images/DressLogo Pics/12.png'
import dress13 from '../images/DressLogo Pics/13.png'
import dress14 from '../images/Blue.jpg'
import dress14a from '../images/Blue2.jpg'
import dress15 from '../images/BabyBlue.jpg'
import dress15a from '../images/BabyBlue2.jpg'

const PromDB = [
    dress1,
    dress1a,
    dress2,
    dress2a,
    dress3,
    dress3a,
    dress4,
    dress4a,
    dress5,
    dress5a,
    dress6,
    dress6a,
    dress7,
    dress7a,
    dress8,
    dress8a,
    dress9,
    dress9a,
    dress10,
    dress10a,
    dress11,
    dress11a,
    dress12,
    dress13,
    dress14,
    dress14a,
    dress15,
    dress15a 
];

export default PromDB